import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import api from "../../Axios/middleware";
import { PayloadAction } from "@reduxjs/toolkit";
import {
    failurelistVideoTutorials,
    successlistVideoTutorials,
} from "./ListVideoTutorialsSlice";

const ListVideoTutorialsApi = (action: PayloadAction<any>) => {
    return api.get("/api/videoTutorials/", {
        params: action.payload,
    });
};

export function* ListVideoTutorialsCall(action: PayloadAction<any>) {
    try {
        const response: AxiosResponse = yield call(ListVideoTutorialsApi, action);
        yield put(successlistVideoTutorials(response.data));
    } catch (error) {
        yield put(failurelistVideoTutorials(error));
    }
}
